// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
import ___CSS_LOADER_URL_IMPORT_0___ from "../../../../resources/images/header-logo-spirit-loading.gif";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3ihTjRuKnkwjjT {\n  background-color: hsla(0, 0%, 100%, 0.3);\n  height: 32px;\n  width: 32px;\n  border-radius: 3px;\n}\n._3TvmOwdWwYQZYx {\n  width: 80px;\n  height: 16px;\n  margin: 7px 0;\n  position: relative;\n  opacity: 0.5;\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n._3TvmOwdWwYQZYx :hover {\n  opacity: 0.8;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonSkeleton": "_3ihTjRuKnkwjjT",
	"newLogo": "_3TvmOwdWwYQZYx"
};
export default ___CSS_LOADER_EXPORT___;
